import { I18n } from '@calendly/i18n';
import { Avatar } from '@calendly/ui/components/avatar';
import { BodyText } from '@calendly/ui/components/typography';
import { colorTextSecondary } from '@calendly/ui/theme';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { Location } from './location';
import { SectionContainer } from './section_container';
import { FullStoryExclude, FullStoryMask } from '../../../../../shared/fullstory_privacy';
import { getDuration } from '../../shared';
const sectionCss = "s3sejbi";
const Section = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(sectionCss, props.className)} />;
});
const hostListCss = "h1sckp4s";
const HostList = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'ul';
  return <Component ref={ref} {...restProps} className={classNames(hostListCss, props.className)} />;
});
const hostItemCss = "h1hzq198";
const HostItem = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'li';
  return <Component ref={ref} {...restProps} className={classNames(hostItemCss, props.className)} />;
});
const Host = ({
  name,
  email,
  avatarUrl,
  avatarLetter
}) => <HostItem>
    <FullStoryExclude>
      <Avatar size="small" src={avatarUrl} letter={avatarLetter} tooltip={name} spacingRight={8} />
    </FullStoryExclude>
    <div>
      <BodyText>
        <FullStoryMask>{name}</FullStoryMask>
      </BodyText>
      <BodyText size="medium" color={colorTextSecondary}>
        <FullStoryMask>{email}</FullStoryMask>
      </BodyText>
    </div>
  </HostItem>;
export const Details = ({
  poll
}) => {
  const {
    duration,
    memberships,
    locationConfigurations
  } = poll;
  const formattedDuration = getDuration(duration);
  const locationKind = locationConfigurations[0]?.kind;
  return <SectionContainer>
      <Section>
        <BodyText size="large" weight="bold">
          {I18n.t('publisher.event_types.hosts')}
        </BodyText>
        <HostList>
          {memberships.map(membership => <Host key={membership.id} {...membership} />)}
        </HostList>
      </Section>
      <Section>
        <BodyText size="large" weight="bold">
          {I18n.t('publisher.event_types.location.location')}
        </BodyText>
        <Location status={poll.status} kind={locationKind} />
      </Section>
      <Section>
        <BodyText size="large" weight="bold">
          {I18n.t('publisher.event_types.availability.duration_fieldset.title')}
        </BodyText>
        <BodyText>
          {formattedDuration}
        </BodyText>
      </Section>
    </SectionContainer>;
};

require("./details.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./details.js");